/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import AssignmentIcon from '@material-ui/icons/Assignment';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import EventIcon from '@material-ui/icons/Event';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import MemoryIcon from '@material-ui/icons/Memory';
import TruePortIcon from '@material-ui/icons/AccessibilityNew';
import TrueScanIcon from '@material-ui/icons/BusinessCenter';
import DashboardIcon from '@material-ui/icons/Dashboard';
import NextWeek from '@material-ui/icons/NextWeek';
import MonitorIcon from '@material-ui/icons/Pageview';
import {
  CELL_GROUPS_VIEW,
  CELL_LOG_ENTRIES_VIEW,
  CELL_WALKS_VIEW,
  CELLS_CONFIG_UPDATE,
  CELLS_VIEW,
  CUSTOMER_EVENTS_VIEW,
  CUSTOMERS_VIEW,
  EVENT_DATA_SETS_VIEW,
  EVENT_MODEL_RUN_REQUESTS_VIEW,
  EVENT_MODEL_WORKERS_VIEW,
  MODEL_CONFIGURATIONS_VIEW,
  MODEL_SETS_VIEW,
  PARTICIPANTS_VIEW,
  PORTAL_USERS_VIEW,
  SOFTWARE_PACKAGES_VIEW,
  TEST_SCENARIOS_VIEW,
  TEST_SESSION_ANALYSIS_VIEW,
  TEST_SESSION_GROUPS_VIEW,
  TEST_SESSIONS_VIEW,
  TRAINING_SCENARIOS_VIEW,
  TRAINING_SESSIONS_VIEW,
  VENUES_VIEW,
  INTEGRATION_PARTNERS_VIEW,
  INVENTORY_COUNTS_VIEW,
  KNOWN_CARRIERS_VIEW,
  TRUE_SCAN_VIEW,
  SCANS_VIEW,
  QUOTE_TOOL_UPLOAD,
  HEVO_STATUS_VIEW,
  VENUE_WEBHOOKS_VIEW
} from 'common/Right';
import ws from 'utils/ws';

export default [
  {
    title: null,
    pages: [
      {
        title: 'Dashboards',
        href: '/org/dashboard/',
        rights: [CELL_WALKS_VIEW],
        icon: DashboardIcon,
        children: [
          {
            type: 'external',
            title: 'Organization',
            href: ws.insight2Url('/dashboard/'),
            right: CELL_WALKS_VIEW
          }
        ]
      },
      {
        title: 'Events',
        href: '/events',
        rights: [CUSTOMER_EVENTS_VIEW],
        icon: EventIcon,
        children: [
          {
            type: 'external',
            title: 'Calendar',
            href: ws.insight2Url('/events/calendar/'),
            right: CUSTOMER_EVENTS_VIEW
          },
          {
            type: 'external',
            title: 'Customer Events',
            href: ws.insight2Url('/events/venue_events/'),
            right: CUSTOMER_EVENTS_VIEW
          }
        ]
      },
      {
        title: 'Monitoring',
        href: '/monitor',
        rights: [CUSTOMER_EVENTS_VIEW],
        icon: MonitorIcon,
        children: [
          {
            type: 'external',
            title: 'Venues',
            href: ws.insight2Url('/monitor/venues/'),
            right: CUSTOMER_EVENTS_VIEW
          },
          {
            type: 'external',
            title: 'Critical Device Logs',
            href: ws.insight2Url('/monitor/device_logs/'),
            right: CELLS_VIEW
          },
          {
            type: 'external',
            title: 'Customer Devices',
            href: ws.insight2Url('/monitor/device_sub_status_summary/'),
            right: CELLS_VIEW
          }
        ]
      },
      {
        title: 'Walks',
        href: '/walks',
        rights: [CELL_WALKS_VIEW],
        icon: DirectionsWalkIcon,
        children: [
          {
            title: 'Walks',
            href: '/walks/cell_walks/',
            right: CELL_WALKS_VIEW
          },
          {
            type: 'external',
            title: 'Warehouse',
            href: ws.insight2Url('/walks/warehouse/'),
            right: CELL_WALKS_VIEW
          },
          {
            title: 'Walk Collections',
            href: '/walks/data_sets/',
            right: EVENT_DATA_SETS_VIEW
          },
          {
            title: 'Analysis',
            href: '/walks/analysis/',
            right: TEST_SESSION_ANALYSIS_VIEW
          }
        ]
      },
      {
        title: 'Scans',
        href: '/scans',
        rights: [SCANS_VIEW],
        icon: NextWeek,
        children: [
          {
            type: 'external',
            title: 'Device Scans',
            href: ws.insight2Url('/scans/device_scans/'),
            right: SCANS_VIEW
          },
          {
            type: 'external',
            title: 'Scan Collections',
            href: ws.insight2Url('/scan_collections/'),
            right: SCANS_VIEW
          }
        ]
      },
      {
        title: 'Models',
        href: '/models',
        rights: [MODEL_CONFIGURATIONS_VIEW],
        icon: MemoryIcon,
        children: [
          {
            type: 'external',
            title: 'Model Types',
            href: ws.insight2Url('/models/'),
            right: MODEL_CONFIGURATIONS_VIEW
          },
          {
            type: 'external',
            title: 'Model Inference',
            href: ws.insight2Url('/models/inference/'),
            right: MODEL_CONFIGURATIONS_VIEW
          },
          {
            type: 'external',
            title: 'Model Analysis',
            href: ws.insight2Url('/models/analysis/'),
            right: MODEL_CONFIGURATIONS_VIEW
          }
        ]
      },
      {
        title: 'Testing',
        href: '/testing',
        rights: [
          TEST_SCENARIOS_VIEW,
          TEST_SESSIONS_VIEW,
          TEST_SESSION_GROUPS_VIEW,
          TEST_SESSION_ANALYSIS_VIEW
        ],
        icon: AssignmentIcon,
        children: [
          {
            title: 'Sessions',
            href: '/testing/sessions/',
            right: TEST_SESSIONS_VIEW
          },
          {
            title: 'Scenarios',
            href: '/testing/scenarios/',
            right: TEST_SCENARIOS_VIEW
          }
        ]
      },
      {
        title: 'Data Collection',
        href: '/training',
        rights: [TRAINING_SCENARIOS_VIEW, TRAINING_SESSIONS_VIEW],
        icon: HowToRegIcon,
        children: [
          {
            title: 'Sessions',
            href: '/training/sessions/',
            right: TRAINING_SESSIONS_VIEW
          },
          {
            title: 'Scenarios',
            href: '/training/scenarios/',
            right: TRAINING_SCENARIOS_VIEW
          },
          {
            title: 'Cells',
            href: '/training/cells_overview/',
            right: TRAINING_SESSIONS_VIEW
          }
        ]
      },
      {
        title: 'TruePort®',
        href: '/deployment',
        rights: [CELLS_VIEW],
        icon: TruePortIcon,
        children: [
          {
            title: 'Devices',
            href: '/deployment/cells/',
            right: CELLS_VIEW
          },
          {
            type: 'external',
            title: 'Inventory Counts',
            href: ws.insight2Url('/trueport/inventory_counts/'),
            right: INVENTORY_COUNTS_VIEW
          },
          {
            type: 'external',
            title: 'Software',
            href: ws.insight2Url('/trueport/software/'),
            right: SOFTWARE_PACKAGES_VIEW
          },
          {
            type: 'external',
            title: 'Critical Logs',
            href: ws.insight2Url('/trueport/critical_logs/'),
            right: CELL_LOG_ENTRIES_VIEW
          },
          {
            type: 'external',
            title: 'Map',
            href: ws.insight2Url('/trueport/map'),
            right: CELLS_VIEW
          },
          {
            title: 'Configuration',
            href: '/deployment/cell_config/',
            right: CELLS_CONFIG_UPDATE
          }
        ]
      },
      {
        title: 'TrueScan™',
        href: '/true_scan',
        rights: [TRUE_SCAN_VIEW, SCANS_VIEW],
        icon: TrueScanIcon,
        children: [
          {
            type: 'external',
            title: 'Devices',
            href: ws.insight2Url('/truescan/devices/'),
            right: TRUE_SCAN_VIEW
          },
          {
            type: 'external',
            title: 'Inventory Counts',
            href: ws.insight2Url('/truescan/inventory_counts/'),
            right: INVENTORY_COUNTS_VIEW
          },
          {
            type: 'external',
            title: 'Software',
            href: ws.insight2Url('/truescan/software/'),
            right: TRUE_SCAN_VIEW
          }
        ]
      },
      {
        title: 'Modelling',
        href: '/models',
        rights: [MODEL_CONFIGURATIONS_VIEW],
        icon: MemoryIcon,
        children: [
          {
            title: 'Models',
            href: '/models/model_configurations/',
            right: MODEL_CONFIGURATIONS_VIEW
          },
          {
            title: 'Model Sets',
            href: '/models/model_sets/',
            right: MODEL_SETS_VIEW
          },
          {
            title: 'Collections Analysis',
            href: '/models/collections_analysis/',
            right: MODEL_CONFIGURATIONS_VIEW
          },
          {
            title: 'NAS Files',
            href: '/models/walks_local_storage/',
            right: MODEL_CONFIGURATIONS_VIEW
          }
        ]
      },
      {
        title: 'Reference',
        href: '/reference',
        rights: [
          PARTICIPANTS_VIEW,
          QUOTE_TOOL_UPLOAD,
          HEVO_STATUS_VIEW,
          VENUE_WEBHOOKS_VIEW
        ],
        icon: LibraryBooksIcon,
        children: [
          {
            title: 'Participants',
            href: '/reference/participants/',
            right: PARTICIPANTS_VIEW
          },
          {
            title: 'Customers',
            href: '/reference/customers/',
            right: CUSTOMERS_VIEW
          },
          {
            type: 'external',
            title: 'Venues',
            href: ws.insight2Url('/reference/venues/'),
            right: VENUES_VIEW
          },
          {
            title: 'Integration Partners',
            href: '/reference/integration_partners/',
            right: INTEGRATION_PARTNERS_VIEW
          },
          {
            title: 'Portal Users',
            href: '/reference/portal_users/',
            right: PORTAL_USERS_VIEW
          },
          {
            title: 'Known Carriers',
            href: '/reference/known_carriers/',
            right: KNOWN_CARRIERS_VIEW
          },
          {
            title: 'Cell Groups',
            href: '/reference/cell_groups/',
            right: CELL_GROUPS_VIEW
          },
          {
            title: 'Quote Tool',
            href: '/reference/quote_tool/',
            right: QUOTE_TOOL_UPLOAD
          },
          {
            title: 'Hevo Status',
            href: '/reference/hevo_status/',
            right: HEVO_STATUS_VIEW
          },
          {
            title: 'Webhooks',
            href: '/reference/webhooks/',
            right: VENUE_WEBHOOKS_VIEW
          }
        ]
      }
    ]
  }
];
